import React, { useState, useContext } from 'react';
import DayCase from './DayCase'; // Importation de la case individuelle
import '../componentsCSS/Calendar.css' // Importer le CSS spécifique à ce composant
import StoryViewer from './StoryViewer'; // Importation de la story
import { UserContext } from '../UserContext';
import { FaUser, FaGifts} from "react-icons/fa";
import Snowfall from 'react-snowfall';
import ConfettiExplosion from "react-confetti-explosion";

const Calendar = ({ days }) => {
  const [isStoryOpen, setIsStoryOpen] = useState(false);
  const [currentStory, setCurrentStory] = useState([]);
  const [showPointsPopup, setShowPointsPopup] = useState(false);
  const [showWinnerPopup, setShowWinnerPopup] = useState(false);
  const [newPoints, setNewPoints] = useState(0);
  const [currentDay, setCurrentDay] = useState(null); // Stocke le jour ouvert
  const { openCase, updateUserDataQuizz } = useContext(UserContext);
  const [isWinner, setIsWinner] = useState(false);
  const [error, setError] = useState("");
  

  const getStoryDataForDay = (day) => {
    if (day ===1 ) {
      return[
        { day: 1, type: "video", url: "https://www.youtube.com/embed/vFyXkx712Vk" },
      ]
    } else if (day === 2) {
      return[
        { day: 2, type: "img", image: `/images/story/Accueil-Quizz.png` },
        { day: 2, type: "poll", image: `/images/story/Contenu-Quizz.png`,
          question: "Quel est le taux de rendement de l’actif des organismes d’assurance vie et mixte en France en 2023 ? ",
          options: [
            `A. 3,0%`,
            `B. 2,8%`,
            `C. 2,2%`,
            `D. 1,8%`,
          ],
          correctIndex: 2, 
          points :3,
         },
         { day: 2, type: "poll", image: `/images/story/Contenu-Quizz.png`,
          question: "Quelle est la moyenne annuelle de la sinistralité climatique en France au cours des quatre dernières années ? ",
          options: [
            `A. 4 Md€`,
            `B. 6 Md€`,
            `C. 8 Md€`,
            `D. 10 Md€`,
          ],
          correctIndex: 1, 
          points :3,
         },
         { day: 2, type: "poll", image: `/images/story/Contenu-Quizz.png`,
          question: "Quel est le niveau de cotisation en 2023 en assurance Automobile ?",
          options: [
            `A. 26 Md€`,
            `B. 30 Md€`,
            `C. 33 Md€`,
            `D. 36 Md€`,
          ],
          correctIndex: 0, 
          points :3,
         },
         { day: 2, type: "poll", image: `/images/story/Contenu-Quizz.png`,
          question: "En assurance non-vie, quel est le type de sinistre le plus fréquent en France ?",
          options: [
            `A. Incendie`,
            `B. Cambriolage`,
            `C. Dégats des eaux`,
            `D. Dommages liés aux catastrophes naturelles`,
          ],
          correctIndex: 2, 
          points :3,
         },
         { day: 2, type: "poll", image: `/images/story/Contenu-Quizz.png`,
          question: "À combien s’élève le montant de prestations réglées dans le cadre de la santé et de la prévoyance en 2023 ?",
          options: [
            `A. 15 Md€`,
            `B. 20 Md€`,
            `C. 27 Md€`,
            `D. 32 Md€`,
          ],
          correctIndex: 2, 
          points :3,
         },
        { day: 2, type: "img", image: `/images/story/Fin-Quizz.png` },
      ]
    } else if (day ===3 ) {
      return[
        { day: 3, type: "img", image: `/images/story/Accueil-video.png` },
        { day: 3, type: "img", image: `/images/story/pres-video-day3.png` },
        { day: 3, type: "video", url: "https://www.youtube.com/embed/5obujYZUCE0" },
      ]
    } else if (day === 4 ) {
      return[
        { day: 4, type: "img", image: `/images/story/Collecte/slide-1.png` },
        { day: 4, type: "img", image: `/images/story/Collecte/slide-2.png` },
        { day: 4, type: "img_lien", 
          image: `/images/story/Collecte/slide-3.png`, 
          link:"https://solidarite.fondationaphp.fr/projects/ensemble-avec-forsides-pour-les-enfants-de-l-hopital-necker",
          linkText: "Cagnotte Forsides en faveur de l'hôpital Necker-Enfants malades"
        },
      ]
    } else if (day === 5 ) {
      return[
        { day: 5, type: "img_pdf", 
          image: `/images/story/day5-technique.png`, 
          pdfUrl: "/images/story/Fiche_synthese-Risque_Inondation.pdf",
          linkText: "Fiche synthèse - Risque innondation"
        },
      ]
    } else if (day ===6 ) {
      return[
        { day: 6, type: "img", image: `/images/story/Accueil-video.png` },
        { day: 6, type: "img", image: `/images/story/pres-video-day4.png` },
        { day: 6, type: "video", url: "https://www.youtube.com/embed/pCUHtJyLXpM" },
      ]
    } else if (day === 7) {
      return[
        { day: 7, type: "img", image: `/images/story/Qui-est-ce/Accueil-Quizz.png` },
        { day: 7, type: "qui-est-ce", image: `/images/story/Qui-est-ce/Contenu-quizz.png`,
          question: "Grâce à l’IA, je me suis découvert une passion pour générer des musiques rythmées, je possède même un label !",
          options: [
            {
              defaultImage: "/images/story/Qui-est-ce/Arnaud.png",
              wrongImage: "/images/story/Qui-est-ce/Arnaud_faux.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/David_G.png",
              correctImage: "/images/story/Qui-est-ce/David_G_correct.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/Vohi.png",
              wrongImage: "/images/story/Qui-est-ce/Vohi_faux.png",
            },
          ],
          correctIndex: 1, 
          points :3,
         },
         { day: 7, type: "qui-est-ce", image: `/images/story/Qui-est-ce/Contenu-quizz.png`,
          question: "J’ai renoncé aux podiums équestres et une perspective de Jeux Olympiques pour devenir actuaire… Parce que, oui, les maths aussi ça donne des montées d’adrénaline ! ",
          options: [
            {
              defaultImage: "/images/story/Qui-est-ce/Meriem.png",
              wrongImage: "/images/story/Qui-est-ce/Meriem_faux.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/Deborah.png",
              wrongImage: "/images/story/Qui-est-ce/Deborah_faux.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/Lea_S.png",
              correctImage: "/images/story/Qui-est-ce/Lea_S_correct.png",
            },
          ],
          correctIndex: 2, 
          points :3,
         },
         { day: 7, type: "qui-est-ce", image: `/images/story/Qui-est-ce/Contenu-quizz.png`,
          question: "Je me retrouve souvent dans des situations embarrassantes et je tombe fréquemment. J'ai même déjà fait un passage sur TF1 à cause d'un accident de karting.",
          options: [
            {
              defaultImage: "/images/story/Qui-est-ce/Louise.png",
              wrongImage: "/images/story/Qui-est-ce/Louise_faux.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/Brice.png",
              wrongImage: "/images/story/Qui-est-ce/Brice_faux.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/Elodie.png",
              correctImage: "/images/story/Qui-est-ce/Elodie_correct.png",
            },
          ],
          correctIndex: 2, 
          points :3,
         },
         { day: 7, type: "qui-est-ce", image: `/images/story/Qui-est-ce/Contenu-quizz.png`,
          question: "J’ai déjà eu une médaille olympique autour du cou.",
          options: [
            {
              defaultImage: "/images/story/Qui-est-ce/Pierre_Nicolas.png",
              wrongImage: "/images/story/Qui-est-ce/Pierre_Nicolas_faux.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/Antoine.png",
              wrongImage: "/images/story/Qui-est-ce/Antoine_faux.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/Pierre_G.png",
              correctImage: "/images/story/Qui-est-ce/Pierre_G_correct.png",
            },
          ],
          correctIndex: 2, 
          points :3,
         },
         { day: 7, type: "qui-est-ce", image: `/images/story/Qui-est-ce/Contenu-quizz.png`,
          question: "J’ai mis beaucoup trop de temps avant de découvrir que le “Grand Marnier” est un alcool, sachant que je ne bois pas d’alcool.",
          options: [
            {
              defaultImage: "/images/story/Qui-est-ce/Mamadou.png",
              correctImage: "/images/story/Qui-est-ce/Mamadou_correct.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/Soukaina.png",
              wrongImage: "/images/story/Qui-est-ce/Soukaina_faux.png",
            },
            {
              defaultImage: "/images/story/Qui-est-ce/Diguema.png",
              wrongImage: "/images/story/Qui-est-ce/Diguema_faux.png",
            },
          ],
          correctIndex: 0, 
          points :3,
         },
        { day: 7, type: "img", image: `/images/story/Fin-Quizz.png` },
      ]
    } else if (day === 8 ) {
      return[
        { day: 8, type: "img", image: `/images/story/Accueil-video.png` },
        { day: 8, type: "video", url: "https://www.youtube.com/embed/u0yhuTxd8PI" },
      ]
    } else if (day === 9 ) {
      // Anecdotes et astuces
      return[
        { day: 9, type: "img", image: `/images/story/Day-9/Accueil.png` },
        { day: 9, type: "img", image: `/images/story/Day-9/Slide-1.png` },
        { day: 9, type: "img", image: `/images/story/Day-9/Slide-2.png` },
        { day: 9, type: "img", image: `/images/story/Day-9/Slide-3.png` },
        { day: 9, type: "img", image: `/images/story/Day-9/Slide-4.png` },
      ]
    } else if (day === 10 ) {
      // Défi cuisine
      return[
        { day: 10, type: "img", image: `/images/story/Defi_cuisine/slide-1.png` },
        { day: 10, type: "img", image: `/images/story/Defi_cuisine/slide-2.png` },
      ]
    } else if (day === 12 ) {
      // Interview Manage
      return[
        { day: 12, type: "img", image: `/images/story/Day-11/Interview_Manager.png` },
        { day: 12, type: "video", url: "https://www.youtube.com/embed/xzMB9BmWMEI" },
      ]
    } else if (day === 11 ) {
      // Contenu technique : SALLTO
      return[
        { day: 11, type: "img", image: `/images/story/Day-12/Contenu_technique.png` },
        { day: 11, type: "video", url: "https://www.youtube.com/embed/TlS2Wn4m5_Y" },
      ]
    } else if (day === 13 ) {
      // Vendredi 13
      return[
        { day: 13, type: "img", image: `/images/story/Day-13/Vendredi-13.png` },
      ]
    } else if (day === 14 ) {
      // politique RSE 
      return[
        { day: 14, type: "img", image: `/images/story/Day-14/Slide-1.png` },
        { day: 14, type: "img", image: `/images/story/Day-14/Slide-2.png` },
        { day: 14, type: "img", image: `/images/story/Day-14/Slide-3.png` },
      ]
    } else if (day === 15 ) {
      // Etude Fun
      return[
        { day: 15, type: "img", image: `/images/story/Day-15/Slide-1.png` },
        { day: 15, type: "img", image: `/images/story/Day-15/Slide-2.png` },
        { day: 15, type: "img", image: `/images/story/Day-15/Slide-3.png` },
      ]
    } else if (day === 16 ) {
      // Vrai ou Faux
      return[
        { day: 16, type: "img", image: `/images/story/Day-16/Slide-1.png` },
        { day: 16, type: "vrai-faux", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Vrai ou faux ? Il existe une assurance qui couvre les frais de correction d'un tatouage mal orthographié.",
          options: [
            `Vrai`,
            `Faux`,
          ],
          correctIndex: 0, 
          points :3,
         },
         { day: 16, type: "vrai-faux", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Vrai ou faux ? Les banques peuvent refuser un prêt en cas d’achat d’un animal exotique.",
          options: [
            `Vrai`,
            `Faux`,
          ],
          correctIndex: 1, 
          points :3,
         },
         { day: 16, type: "vrai-faux", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Vrai ou faux ? Un fonds d’investissement en bourse est spécifiquement dédié à la valeur des cartes Pokémon.",
          options: [
            `Vrai`,
            `Faux`,
          ],
          correctIndex: 0, 
          points :3,
         },
         { day: 16, type: "vrai-faux", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Vrai ou faux ? Les données d’utilisation de TikTok ont été analysées pour prédire les élections présidentielles dans des pays comme les États-Unis.",
          options: [
            `Vrai`,
            `Faux`,
          ],
          correctIndex: 0, 
          points :3,
         },
         { day: 16, type: "vrai-faux", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Vrai ou faux ? Certains assureurs ont lancé une couverture contre les pertes financières dues à une mauvaise coupe de cheveux.",
          options: [
            `Vrai`,
            `Faux`,
          ],
          correctIndex: 0, 
          points :3,
         },
         { day: 16, type: "vrai-faux", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Vrai ou faux ? Il existe une assurance qui couvre la perte de cheveux causée par un stress intense lors d'un entretien d'embauche.",
          options: [
            `Vrai`,
            `Faux`,
          ],
          correctIndex: 1, 
          points :3,
         },
         { day: 16, type: "vrai-faux", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Vrai ou faux ? Les actuaires ont prédit que l'extinction des moustiques entraînera une diminution significative des catastrophes naturelles.",
          options: [
            `Vrai`,
            `Faux`,
          ],
          correctIndex: 1, 
          points :3,
         },
         { day: 16, type: "vrai-faux", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Vrai ou faux ? La probabilité de mourir d'un coup de foudre est plus élevée en cas de port d’un parapluie.",
          options: [
            `Vrai`,
            `Faux`,
          ],
          correctIndex: 1, 
          points :3,
         },
      ]
    } else if (day === 17 ) {
      // Vis ma vie de consultant
      return[
        { day: 17, type: "video", url: "https://www.youtube.com/embed/0IQS8EGSE8E?si" },
      ]
    } else if (day === 18 ) {
      // Récap QVT
      return[
        { day: 18, type: "video", url: "https://www.youtube.com/embed/w86HZ5sRO4Y" },
      ]
    } else if (day === 19 ) {
      // Contenu technique : Evolution marché des assurances
      return[
        { day: 19, type: "img_pdf", 
          image: `/images/story/Day-19/Contenu_technique.png`, 
          pdfUrl: "/images/story/Day-19/Forsides-Evolution_ marche_des_assurances.pdf",
          linkText: "Evolution du marché des assurances"
        },
      ]
    } else if (day === 20) {
      // Quizz
      return[
        { day: 20, type: "img", image: `/images/story/Accueil-Quizz.png` },
        { day: 20, type: "poll", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Thème : Cinéma\nQuel film a remporté l’Oscar du meilleur film en 2023 ?",
          options: [
            `Avatar : La Voie de l’eau`,
            `Top Gun : Maverick`,
            `Les Banshees d’Inisherin`,
            `Everything Everywhere All at Once`,
          ],
          correctIndex: 3, 
          points :3,
         },
         { day: 20, type: "poll", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Thème : Sport\nQuel est le seul club français à avoir remporté la Ligue des Champions de football ?",
          options: [
            `Paris Saint-Germain`,
            `AS Monaco`,
            `Olympique Lyonnais`,
            `Olympique de Marseille`,
          ],
          correctIndex: 3, 
          points :3,
         },
         { day: 20, type: "poll", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Thème : Géographie\nQuel est le plus petit pays du monde ?",
          options: [
            `Monaco`,
            `Nauru`,
            `Vatican`,
            `Saint Martin`,
          ],
          correctIndex: 2, 
          points :3,
         },
         { day: 20, type: "poll", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Thème : Gastronomie\nQuel chef a remporté le plus grand nombre d’étoiles Michelin au monde ?",
          options: [
            `Gordon Ramsay`,
            `Alain Ducasse`,
            `Thomas Keller`,
            `Joël Robuchon`,
          ],
          correctIndex: 1, 
          points :3,
         },
         { day: 20, type: "poll", image: `/images/story/Day-16/Contenu-quizz.png`,
          question: "Thème : Musique\nQuel événement marquant a eu lieu lors de la réouverture de Notre-Dame de Paris en décembre 2024 ?",
          options: [
            `Une performance exclusive de Beyoncé`,
            `Un concert avec Clara Luciani Vianney et Garou`,
            `La présentation du nouvel album de Jul`,
            `Un duo inédit entre Stromae et Angèle`,
          ],
          correctIndex: 1, 
          points :3,
         },
        { day: 20, type: "img", image: `/images/story/Fin-Quizz.png` },
      ]
    } else if (day === 21 ) {
      // Contenu technique : STORM
      return[
        { day: 21, type: "img", image: `/images/story/Day-21/Contenu_technique.png` },
        { day: 21, type: "video", url: "https://www.youtube.com/embed/T-6JUNGb7cU" },
      ]
    } else if (day === 22 ) {
      // Présentation des GT
      return[
        { day: 22, type: "img", image: `/images/story/Day-22/Slide-1.png` },
        { day: 22, type: "img", image: `/images/story/Day-22/Slide-2.png` },
        { day: 22, type: "img", image: `/images/story/Day-22/Slide-3.png` },
        { day: 22, type: "img", image: `/images/story/Day-22/Slide-4.png` },
      ]
    } else if (day === 23 ) {
      // Sujet métier
      return[
        { day: 23, type: "img_pdf", 
          image: `/images/story/Day-23/Slide-1.png`,
          pdfUrl: "/images/story/Day-23/Synthese-Fonds_croissance.pdf",
          linkText: "Fiche synthèse - Fonds croissance"
        },
        { day: 23, type: "img_pdf", 
          image: `/images/story/Day-23/Slide-2.png`, 
          pdfUrl: "/images/story/Day-23/Memoire_IA_fonds_croissance.pdf",
          linkText: "Mémoire IA - Fonds croissance"
        }
      ]
    } else if (day === 24 ) {
      // Défis cuisine du monde
      return[
        { day: 24, type: "img", image: `/images/story/Day-24/Slide-1.png` },
      ]
    } else if (day === 25 ) {
      // Vidéo Noel
      return[
        { day: 25, type: "video", url: "https://www.youtube.com/embed/KcXXVwasGv0" },
      ]
    } else if (day === 26) {
      return[
        { day: 26, type: "img", image: `/images/story/Day-26/Accueil-Quizz.png` },
        { day: 26, type: "qui-est-ce", image: `/images/story/Day-26/Contenu-quizz.png`,
          question: "J’ai un domaine viticole à mon nom ainsi qu’une cuvée à mon prénom",
          options: [
            {
              defaultImage: "/images/story/Day-26/Lea_V.png",
              correctImage: "/images/story/Day-26/Lea_V_vrai.png",
            },
            {
              defaultImage: "/images/story/Day-26/Alexandre.png",
              wrongImage: "/images/story/Day-26/Alexandre_faux.png",
            },
            {
              defaultImage: "/images/story/Day-26/Edouard.png",
              wrongImage: "/images/story/Day-26/Edouard_faux.png",
            },
          ],
          correctIndex: 0, 
          points :3,
         },
         { day: 26, type: "qui-est-ce", image: `/images/story/Day-26/Contenu-quizz.png`,
          question: "J’ai joué dans plusieurs œuvres à l’opéra de Toulouse",
          options: [
            {
              defaultImage: "/images/story/Day-26/Mamadou.png",
              wrongImage: "/images/story/Day-26/Mamadou_faux.png",
            },
            {
              defaultImage: "/images/story/Day-26/Maxime.png",
              correctImage: "/images/story/Day-26/Maxime_vrai.png",
            },
            {
              defaultImage: "/images/story/Day-26/Rakia.png",
              wrongImage: "/images/story/Day-26/Rakia_faux.png",
            },
          ],
          correctIndex: 1, 
          points :3,
         },
         { day: 26, type: "qui-est-ce", image: `/images/story/Day-26/Contenu-quizz.png`,
          question: "Je ne cours presque jamais, 3 pas de course derrière un bus ont suffit à me garantir une entorse pendant 6 mois",
          options: [
            {
              defaultImage: "/images/story/Day-26/Leo.png",
              wrongImage: "/images/story/Day-26/Leo_faux.png",
            },
            {
              defaultImage: "/images/story/Day-26/Varlam.png",
              wrongImage: "/images/story/Day-26/Varlam_faux.png",
            },
            {
              defaultImage: "/images/story/Day-26/Ketshia.png",
              correctImage: "/images/story/Day-26/Ketshia_vrai.png",
            },
          ],
          correctIndex: 2, 
          points :3,
         },
         { day: 26, type: "qui-est-ce", image: `/images/story/Day-26/Contenu-quizz.png`,
          question: "J’ai traversé une réserve à Puma à pied pendant 3 jours en Argentine",
          options: [
            {
              defaultImage: "/images/story/Day-26/Louise.png",
              wrongImage: "/images/story/Day-26/Louise_faux.png",
            },
            {
              defaultImage: "/images/story/Day-26/Antoine.png",
              correctImage: "/images/story/Day-26/Antoine_vrai.png",
            },
            {
              defaultImage: "/images/story/Day-26/Deborah.png",
              wrongImage: "/images/story/Day-26/Deborah_faux.png",
            },
          ],
          correctIndex: 1, 
          points :3,
         },
         { day: 26, type: "qui-est-ce", image: `/images/story/Day-26/Contenu-quizz.png`,
          question: "Je suis médiateur (trice), j’ai appris à résoudre tout type de conflit au centre de médiation et d’arbitrage de PARIS (CMAP) ",
          options: [
            {
              defaultImage: "/images/story/Day-26/Guillaume.png",
              wrongImage: "/images/story/Day-26/Guillaume_faux.png",
            },
            {
              defaultImage: "/images/story/Day-26/Charlene.png",
              wrongImage: "/images/story/Day-26/Charlene_faux.png",
            },
            {
              defaultImage: "/images/story/Day-26/Arnaud.png",
              correctImage: "/images/story/Day-26/Arnaud_vrai.png",
            },
          ],
          correctIndex: 2, 
          points :3,
         },
        { day: 26, type: "img", image: `/images/story/Fin-Quizz.png` },
      ]
    } else if (day === 27 ) {
      // Sujet métier
      return[
        { day: 27, type: "img_pdf", 
          image: `/images/story/Day-27/Slide-1.png`,
          pdfUrl: "/images/story/Day-27/Forsides_l_essort_des_captives.pdf",
          linkText: "Morning - l'essort des captives"
        },
        { day: 27, type: "img_pdf", 
          image: `/images/story/Day-27/Slide-2.png`, 
          pdfUrl: "/images/story/Day-27/Forsides_captive_EB.pdf",
          linkText: "Morning - Captive EB"
        }
      ]
    } else if (day === 28 ) {
      // Le saviez vous ?
      return[
        { day: 28, type: "img", image: `/images/story/Day-28/Slide-1.png` },
        { day: 28, type: "img", image: `/images/story/Day-28/Slide-2.png` },
      ]
    } else if (day === 29 ) {
      // Le saviez vous ?
      return[
        { day: 29, type: "img", image: `/images/story/Day-29/Slide-1.png` },
        { day: 29, type: "img", image: `/images/story/Day-29/Slide-2.png` },
      ]
    } else if (day === 30 ) {
      // Le saviez vous ?
      return[
        { day: 30, type: "img", image: `/images/story/Day-30/Slide-1.png` },
        { day: 30, type: "img", image: `/images/story/Day-30/Slide-2.png` },
      ]
    } else if (day === 31 ) {
      // Vidéo QUi-est-ce
      return[
        { day: 31, type: "video", url: "https://www.youtube.com/embed/THtTKVah1s4" },
      ]
    };
  };


  const handlePointsEarned = (points) => {
    setNewPoints(newPoints + points); // Mettez à jour les points gagnés
  };

  const handleOpenStory = async (day) => {
    try {
      // Appeler la méthode du contexte pour effectuer la connexion
      const result = await openCase(day);
      console.log("Ouverture de case réussie");

      setNewPoints(result.points_earned);
      setIsWinner(result.is_winner);
  } catch (err) {
      console.error("Erreur lors de l'ouverture de la case :", err);
      setError("Une erreur est survenue lors de l'ouverture de la case. Veuillez réessayer.");
      console.log(error)
  }

  if (isWinner) {
    setCurrentDay(day);
    setShowWinnerPopup(true)
  }
  else {
    setCurrentStory(getStoryDataForDay(day));
    setCurrentDay(day);
    setIsStoryOpen(true);
  }
  };

  const handleCloseStory = (dayQuizzUserData, needUpdate, day) => {
    setIsStoryOpen(false);
    if (needUpdate) {
      console.log(dayQuizzUserData, newPoints)
      updateUserDataQuizz(dayQuizzUserData, newPoints, day);
    }
    // Déclenche le pop-up des points uniquement si des points ont été gagnés
    setShowPointsPopup(newPoints > 0);
  };

  const handleCloseWinnerPopup = () => {
    setShowWinnerPopup(false)
    setCurrentStory(getStoryDataForDay(currentDay));
    setCurrentDay(currentDay);
    setIsStoryOpen(true);
  }

  return (
    <div className='calendar-background'>
      {/* Effet de neige */}
      <Snowfall 
          color="white" /* Couleur des flocons */
          snowflakeCount={400} /* Nombre de flocons visibles */
          style={{
              height: '100%',
              zIndex: 9999, // Assure que la neige est visible devant les autres éléments
            }}
      />
      <div className="calendar">
        {days.map((day, index) => (
          <DayCase key={index} day={day} onClick={handleOpenStory} />
        ))}

        {isStoryOpen && (
          <StoryViewer
            slides={currentStory}
            onClose={(dayQuizzUserData, needUpdate, day) => handleCloseStory(dayQuizzUserData, needUpdate, day)}
            day={currentDay}
            onPointsEarned={handlePointsEarned}
          />
        )}
        

        {showPointsPopup && (
          <div className="point-popup-overlay" onClick={() => setShowPointsPopup(false)}>
            <div className="wrapper" >
              <div className="point-popup" onClick={(e) => e.stopPropagation()}>
                <h2>Bravo !</h2>
                <h1><FaUser className="icon" /></h1>
                <h4>Vous avez gagné {newPoints} points !</h4>
                <p>Merci de participer au calendrier du Secret Forsides !</p>
                <p>Découvrez chaque jour une nouvelle case à ouvrir, certaines vous réservent des surprises !</p>
                
                <button 
                className="point-button"
                onClick={() => (setShowPointsPopup(false) || setNewPoints(0))}
                >Continuer</button>
              </div>
            </div>
        </div>
        )}

        {showWinnerPopup && (
          <div className="point-popup-overlay" onClick={() => handleCloseWinnerPopup()}>
            <div className="confetti-container">
      <ConfettiExplosion
        force={0.8}
        duration={5000}
        particleCount={250}
        width={1600}
        colors={["#ff0a54", "#ff477e", "#ff7096", "#ff85a1", "#fbb1bd"]}
        zIndex={9999}
      />
    </div>
            <div className="wrapper" >
              <div className="point-popup" onClick={(e) => e.stopPropagation()}>
                <h2>!! Vous avez gagnez !!</h2>
                <h1><FaGifts className="icon" /></h1>
                <h4>Vous remportez un super cadeau ! 🥳</h4>
                <p>Vous serez contacter par mail dans les prochaines 24h par Forsides afin de le récupérer.</p>
                <p>Merci de participer au calendrier du Secret Forsides !</p>
                
                <button 
                className="point-button"
                onClick={() => handleCloseWinnerPopup()}
                >Continuer</button>
              </div>
            </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Calendar;